<template>
	<div class="sk-widget-alt" ref="contactForm">
		<form>
			<div class="contact-details">
				<SkInput
					:ref="'firstNameInput'"
					:name="'First Name'"
					:placeholder="'John'"
					:required="true"
					v-model="firstname"
					data-cy="contact-form-first-name"
				/>
				<SkInput
					:ref="'lastNameInput'"
					:name="'Last Name'"
					:placeholder="'Smith'"
					:required="true"
					v-model="lastname"
					data-cy="contact-form-last-name"
				/>
			</div>
			<div class="contact-details mobile-column">
				<SkInput
					v-if="showLocationInput"
					:name="locationName"
					v-model="location"
					data-cy="contact-form-location"
				/>
				<SkTelephoneInput
					:ref="'phoneInput'"
					v-model="phone"
					data-cy="contact-form-phone"
				/>
			</div>
			<SkInput
				class="email-input"
				:ref="'emailInput'"
				:name="'Email'"
				:type="'email'"
				:required="true"
				:validation="emailRegex"
				:placeholder="'jsmith@gmail.com'"
				v-model="email"
				data-cy="contact-form-email"
			/>
		</form>
	</div>
</template>

<style scoped>
.contact-details {
	display: flex;
	margin-bottom: 18px;
}

.contact-details .sk-input-wrapper + .sk-input-wrapper {
	margin-left: 15px;
}
.sk-widget-alt {
	border: none;
}
form {
	background-color: var(--sk-grey-bg);
}

@media only screen and (max-width: 550px) {
	.mobile-column {
		flex-direction: column;
	}

	.mobile-column.contact-details > div + div {
		margin-top: 18px;
	}

	.mobile-column.contact-details .sk-input-wrapper + .sk-input-wrapper {
		margin-left: 0;
	}
}
</style>

<script>
import { DeliveryMode } from "@reef-os/utils/enums/deliveryMode"
import { PaymentType } from "@reef-os/utils/enums/paymentType"
import locationNameFormatterMixin from "@/mixins/location-name-formatter-mixin"
import SkInput from "@/components/common/SkInput.vue"
import SkTelephoneInput from "@/components/common/SkTelephoneInput.vue"

export default {
	name: "DefaultContactForm",
	mixins: [locationNameFormatterMixin],
	components: {
		SkInput,
		SkTelephoneInput
	},
	props: {
		container: HTMLDivElement,
		paymentMethod: Number
	},
	data: function () {
		return {
			open: false,
			emailRegex:
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		}
	},
	computed: {
		tosUrl() {
			return "/" + this.$route.params.slug + "/terms_of_use"
		},
		privacyUrl() {
			return "/" + this.$route.params.slug + "/privacy"
		},
		firstname: {
			get: function () {
				return this.$store.state.user.firstname
			},
			set: function (newVal) {
				this.$store.dispatch("setUserFirstName", newVal)
				this.$store.dispatch(
					"setUsername",
					`${this.firstname} ${this.lastname}`
				)
			}
		},
		lastname: {
			get: function () {
				return this.$store.state.user.lastname
			},
			set: function (newVal) {
				this.$store.dispatch("setUserLastName", newVal)
				this.$store.dispatch(
					"setUsername",
					`${this.firstname} ${this.lastname}`
				)
			}
		},
		phone: {
			get: function () {
				return this.$store.state.user.phone
			},
			set: function (newVal) {
				this.$store.dispatch("setUserPhone", newVal)
			}
		},
		email: {
			get: function () {
				return this.$store.state.user.email
			},
			set: function (newVal) {
				this.$store.dispatch("setUserEmail", newVal)
			}
		},
		location: {
			get: function () {
				return this.$store.getters.table != undefined &&
					this.$store.getters.table != null
					? `${this.$store.getters.table}`
					: ""
			},
			set: function (newVal) {
				this.$store.dispatch("setCurrentTable", newVal)
			}
		},
		locationName() {
			const businessType = this.$store.state.business
				? this.$store.state.business.type
				: -1
			return this.$options.filters.locationName(businessType)
		},
		showLocationInput() {
			if (this.paymentMethod == PaymentType.IN_ROOM_BILLING) {
				return true
			}

			if (this.$store.getters.isAirport) {
				return false
			}

			switch (this.$store.getters.deliveryMode) {
				case DeliveryMode.DIRECT_TO_LOCATION:
				case DeliveryMode.LAST_YARD: {
					return true
				}
			}
			return false
		}
	},
	methods: {
		validate() {
			const firstNameInvalid = !this.$refs.firstNameInput.validate()
			const lastNameInvalid = !this.$refs.lastNameInput.validate()
			const phoneInvalid = !this.$refs.phoneInput.validate()
			const emailInvalid = !this.$refs.emailInput.validate()
			let invalidInput = null
			let trackingData = null
			if (firstNameInvalid) {
				invalidInput = this.$refs.firstNameInput
				trackingData = {
					reason: "Invalid First Name",
					contact_name: this.name
				}
			} else if (lastNameInvalid) {
				invalidInput = this.$refs.lastNameInput
				trackingData = {
					reason: "Invalid Last Name",
					contact_name: this.name
				}
			} else if (phoneInvalid) {
				invalidInput = this.$refs.phoneInput
				trackingData = {
					reason: "Invalid Phone",
					contact_phone: this.phone
				}
			} else if (emailInvalid) {
				invalidInput = this.$refs.emailInput
				trackingData = {
					reason: "Invalid Email",
					contact_email: this.email
				}
			}
			if (invalidInput) {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Contact Form Invalid",
					data: trackingData
				})
				this.focusInput(invalidInput)
			}
			return invalidInput
		},
		focusInput(input) {
			if (this.container) {
				this.container.scroll({
					top: input.$el.offsetTop - this.container.offsetTop - 15,
					behavior: "smooth"
				})
				setTimeout(() => {
					input.focusInput()
				}, 500)
			} else {
				input.focusInput()
			}
		}
	}
}
</script>